const exceptionMessages = {
  NOMERCHANT: 'Technicians without a submerchant cannot be activated!'
};

const getExceptionMessage = (message) => exceptionMessages[message] || message;

export default getExceptionMessage;
